<template>
  <v-card>
    <validation-observer ref="obs" v-slot="{ errors, invalid, valid }">
      <v-toolbar color="titleBar" dark flat dense>
        <v-toolbar-title>{{ $t("cross connect order") }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <validation-provider
              :vid="rack"
              :name="$t('rack')"
              rules="required"
              v-slot="{ errors, valid, dirty, classes }"
            >
              <v-select
                v-model="rack"
                :items="racks"
                item-text="rack"
                item-value="rack"
                :label="$t('rack')"
                :disabled="loading || creatingTicket"
                clearable
                :error-messages="errors"
                :success="valid && dirty"
                :class="classes"
              />
          </validation-provider>
          </v-col>
          <v-col cols="12" md="6">
            <validation-provider
              :vid="patchFrom"
              :name="$t('patch from')"
              rules="required|max:255"
              v-slot="{ errors, valid, dirty, classes }"
            >
            <v-text-field
              v-model="patchFrom"
              :label="$t('patch from')"
              :disabled="creatingTicket"
              clearable
              :error-messages="errors"
              :success="valid && dirty"
              :class="classes"
            />
          </validation-provider>
          </v-col>
          <v-col cols="12" md="6">
            <validation-provider
              :vid="patchTo"
              :name="$t('patch to')"
              rules="required|max:255"
              v-slot="{ errors, valid, dirty, classes }"
            >
            <v-text-field
              v-model="patchTo"
              :label="$t('patch to')"
              :disabled="creatingTicket"
              clearable
              :error-messages="errors"
              :success="valid && dirty"
              :class="classes"
            />
          </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <validation-provider
              :vid="note"
              :name="$t('order note')"
              rules="max:1024"
              v-slot="{ errors, valid, dirty, classes }"
            >
              <v-textarea
                v-model="note"
                :label="$t('order note')"
                :disabled="creatingTicket"
                clearable
                :error-messages="errors"
                :success="valid && dirty"
                :class="classes"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="createTicket"
          :disabled="creatingTicket || invalid"
          :loading="creatingTicket"
          text
        >
          {{ $t("order") }}
        </v-btn>
      </v-card-actions>
    </validation-observer>
  </v-card>
</template>

<script>
import showErrors from "@/utils/mixins/showErrors";
import isMobile from "@/utils/mixins/isMobile";

export default {
  name: "RzoCrossConnect",
  mixins: [showErrors, isMobile],
  
  data: () => ({
    rack: null,
    racks: [],
    patchFrom: null,
    patchTo: null,
    note: null,
    loading: false,
    creatingTicket: false,
  }),
  computed: {
    customerId() {
      return this.$store.getters.customerId;
    },
    subject() {
      return this.$t("cross connect order") + ": " + this.rack;
    },
    message() {
      return (
        (this.$t("patch from") + ": " + (this.patchFrom || "")) + "\n" +
        (this.$t("patch to") + ": " + (this.patchTo || "")) + "\n" +
        (this.$t("order note") + ": " + (this.note || "-"))
      );
    }
  },
  watch: {
    customerId(value) {
      if (value != null) {
        this.getRacks();
        this.rack = null;
      }
    },
  },
  methods: {
    getRacks() {
      var that = this;
      this.loading = true;
      this.$http
        .get("services/rzo/power/racks", {
          params: {
            optional: false,
          },
        })
        .then((response) => {
          that.racks = response.data;
        })
        .catch(function (error) {
          that.$store.commit("setSystemError", {
            msg: error.message,
            title: error.title,
          });
        })
        .finally(function () {
          that.loading = false;
        });
    },
    createTicket() {
      var that = this;
      this.creatingTicket = true;
      this.$http
        .post("customers/" + this.customerId + "/ticket", {
          email: this.email || null,
          subject: this.subject,
          message: this.message,
          note: this.note || null,
        })
        .then((response) => {
          that.$emit("ticketCreated", response.data);
        })
        .catch(function (error) {
          that.$store.commit("setSystemError", {
            msg: error.message,
            title: error.title,
          });
        })
        .finally(function () {
          that.creatingTicket = false;
        });
    },
  },
  mounted() {
    this.getRacks();
  },
};
</script>


<i18n>
{
  "en": {
    "order": "order",
    "rack": "Rack",
    "cross connect order": "Cross Connect Order",
    "patch from": "Patch From: ",
    "patch to": "Patch To: ",
    "order note": "Order Note"
  },
  "de": {
    "order": "bestellen",
    "rack": "Rack",
    "cross connect order": "Cross Connect Bestellung",
    "patch from": "Patch von: ",
    "patch to": "Patch nach: ",
    "order note": "Bestellnotiz"
  }
}
</i18n>
